import React, { useState, useEffect } from 'react';
import { Table, Card, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { FaDownload } from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";

const StatementOfAccounts = () => {
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [soaData, setSoaData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({
        openingBalance: 0,
        totalDebit: 0,
        totalCredit: 0,
        totalVAT: 0,
        closingBalance: 0,
        currency: 'AED'
    });
    const [partners, setPartners] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState('');

    // Fetch clients on mount
    useEffect(() => {
        fetchClients();
        // fetchPartners();
    }, []);
    const fetchPartners = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation?org_type=partner`, {
                headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
            });
            setPartners(response.data.data || []);
        } catch (error) {
            console.error('Error fetching partners:', error);
        }
    };

    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=client`, {
                headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
            });

            setClients(response.data.Data || []);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };
    const [partnerProjects, setPartnerProjects] = useState([]);

    const fetchPartnerProjects = async () => {
        if (!selectedPartner) return alert("Please select a partner");

        setLoading(true);
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/deals?partner_id=${selectedPartner}`, {
                headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
            });

            const projects = response.data.data || [];

            // Fetch transactions for each project
            for (const proj of projects) {
                const dealsResponse = await axios.get(`${backendUrl}/api/deals?project_id=${proj.id}`, {
                    headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
                });
                const invoicesResponse = await axios.get(`${backendUrl}/api/proformainvoice?project_id=${proj.id}`, {
                    headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
                });
                const paymentsResponse = await axios.get(`${backendUrl}/api/transactions?project_id=${proj.id}&type=income`, {
                    headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
                });

                // Process project SOA
                const processedData = processSOAData(
                    dealsResponse.data.data || [],
                    invoicesResponse.data.proformainvoice || [],
                    paymentsResponse.data.data || [],
                    'AED', // assuming AED; you can fetch per project currency if needed
                    0.05
                );

                proj.transactions = processedData.transactions;
            }

            setPartnerProjects(projects);
        } catch (error) {
            console.error('Error fetching partner projects:', error);
        } finally {
            setLoading(false);
        }
    };



    const fetchSOAData = async () => {
        if (!selectedClient) return alert('Please select a client');

        setLoading(true);
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Fetch client details
            const clientResponse = await axios.get(`${backendUrl}/api/contacts/${selectedClient}?type=client`, {
                headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
            });
            console.log('clientre', clientResponse.data.Data);
            const clientCurrency = clientResponse.data.Data?.currency || 'AED';
            console.log('Client Currency:', clientCurrency);

            const isAED = clientCurrency === 'AED';
            const vatRate = isAED ? 0.05 : 0;
            const params = new URLSearchParams();
            params.append('client_id', selectedClient);
            if (startDate) params.append('start_date', startDate);
            if (endDate) params.append('end_date', endDate);

            // Fetch all required data
            const [dealsResponse, invoicesResponse, paymentsResponse] = await Promise.all([
                axios.get(`${backendUrl}/api/deals?${params.toString()}&stage=order`, {
                    headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
                }),
                axios.get(`${backendUrl}/api/proformainvoice?${params.toString()}`, {
                    headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
                }),
                axios.get(`${backendUrl}/api/transactions?${params.toString()}&type=income`, {
                    headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
                })
            ]);

            // Filter invoices for selected client
            const filteredInvoices = (invoicesResponse.data.proformainvoice || []).filter(invoice =>
                invoice.quotation?.project?.client?.id == selectedClient
            );
            //             const clientDeals = (dealsResponse.data.data || []).filter(
            //     deal => deal.client_id == selectedClient
            // );
              console.log('=== PAYMENTS DATA STRUCTURE ===');
        console.log('Total payments:', paymentsResponse.data.data?.length || 0);
        if (paymentsResponse.data.data && paymentsResponse.data.data.length > 0) {
            console.log('First payment sample:', JSON.stringify(paymentsResponse.data.data[0], null, 2));
            
            // Check what invoice-related fields exist
            const firstPayment = paymentsResponse.data.data[0];
            console.log('Payment has invoice_id?', 'invoice_id' in firstPayment);
            console.log('Payment has reference_invoice_id?', 'reference_invoice_id' in firstPayment);
            console.log('Payment has invoices array?', firstPayment.invoices && Array.isArray(firstPayment.invoices));
            if (firstPayment.invoices && firstPayment.invoices.length > 0) {
                console.log('First invoice in payment:', JSON.stringify(firstPayment.invoices[0], null, 2));
            }
            console.log('Payment has transaction_invoice_items?', firstPayment.transaction_invoice_items && Array.isArray(firstPayment.transaction_invoice_items));
        }
        console.log('=== END DEBUG ===');


            const processedData = processSOAData(
                dealsResponse.data.data || [],
                filteredInvoices,
                paymentsResponse.data.data || [],
                clientCurrency,
                vatRate
            );

            setSoaData(processedData.transactions);
            setSummary(processedData.summary);

        } catch (error) {
            console.error('Error fetching SOA data:', error);
            alert('Error fetching SOA data. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const getDayjsDate = (dateString) => {
        return dateString ? dayjs(dateString) : null;
    };

    // const processSOAData = (deals, invoices, transactions, currency, vatRate) => {
    //     const isAED = currency === 'AED';
    //     const groupedData = [];
    //     let runningBalance = 0;
    //     let totalDebit = 0;
    //     let totalCredit = 0;
    //     let totalVAT = 0;
    //     let totalAdvance = 0;
    //     let carryForwardAdvance = 0;

    //     // Step 1: Map quotation_id → deal_id
    //     const quotationToDealMap = {};
    //     deals.forEach(deal => {
    //         if (deal.quotation_id) {
    //             quotationToDealMap[deal.quotation_id] = deal.id;
    //         }
    //     });

    //     // Step 2: Group invoices by deal_id
    //     const invoicesByDeal = {};
    //     invoices.forEach(inv => {
    //         const dealId = quotationToDealMap[inv.quotation_id] || inv.deal_id;

    //         if (!dealId) {
    //             console.warn('Invoice not linked to a deal:', inv.ref_no);
    //             return;
    //         }

    //         if (!invoicesByDeal[dealId]) invoicesByDeal[dealId] = [];
    //         invoicesByDeal[dealId].push(inv);
    //     });

    //     // Group payments by invoice_id
    //     const paymentsByInvoice = {};
    //     transactions.forEach(tx => {
    //         const invoiceId = tx.invoice_id || tx.reference_invoice_id;
    //         if (!invoiceId) return;
    //         if (!paymentsByInvoice[invoiceId]) paymentsByInvoice[invoiceId] = [];
    //         paymentsByInvoice[invoiceId].push(tx);
    //     });

    //     // Process each deal
    //     const orderedDeals = [...deals].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

    //     orderedDeals.forEach(deal => {
    //         const relatedInvoices = invoicesByDeal[deal.id] || [];
    //         const hasPayments = relatedInvoices.some(inv => (paymentsByInvoice[inv.id] || []).length > 0);

    //         if (relatedInvoices.length === 0 && !hasPayments) return;

    //         // 1️⃣ Order row
    //         groupedData.push({
    //             date: deal.issue_date,
    //             type: 'Sales Declaration',
    //             reference: deal.po_number,
    //             description: `Order '${deal.name}' confirmed.`,
    //             debit: 0,
    //             credit: 0,
    //             advance: 0,
    //             runningBalance,
    //             meta: { kind: 'order' }
    //         });

    //         // 2️⃣ Process invoices
    //         relatedInvoices.forEach(inv => {
    //             const amount = Number(inv.basic_amount) || 0;
    //             const vat = isAED ? Number(inv.vat) || 0 : 0;
    //             const total = Number(inv.total_with_vat) || (amount + vat);
    //             totalDebit += total;
    //             totalVAT += vat;
    // const invoiceDate = inv.invoice_date || inv.created_at;

    //             // Apply carry-forward advance
    //             let appliedAdvance = 0;
    //             if (carryForwardAdvance > 0) {
    //                 appliedAdvance = Math.min(carryForwardAdvance, total);
    //                 carryForwardAdvance -= appliedAdvance;
    //             }
    //             runningBalance += (total - appliedAdvance);
    //             totalCredit += appliedAdvance;
    //             // 2️⃣a Invoice row first
    //             groupedData.push({
    //                 date: invoiceDate,
    //                 type: 'Invoice Raised',
    //                 reference: inv.ref_no || `INV-${inv.id}`,
    //                 description: `Invoice '${inv.ref_no}' for project '${inv.quotation?.project?.name || 'N/A'}'.`,
    //                 debit: total,
    //                 credit: appliedAdvance,
    //                 advance: 0, // temporarily, will add overpayment from payments below
    //                 runningBalance,
    //                 meta: { kind: 'invoice', invoiceId: inv.id }
    //             });

    //             // 2️⃣b Payments for this invoice (after invoice row)
    //             const relatedPayments = paymentsByInvoice[inv.id] || [];
    //             let invoiceAdvance = 0;
    //             // relatedPayments.forEach(tx => {
    //             //     const paid = Math.abs(Number(tx.amount)) || 0;
    //             //     const received = Number(tx.received_amount) || paid;
    //             //     const overpaid = received - paid;
    //             //     if (overpaid > 0) invoiceAdvance += overpaid;
    //             //     totalCredit += paid;
    //             //     runningBalance -= paid;

    //             //     groupedData.push({
    //             //         date: tx.date,
    //             //         type: 'Payment',
    //             //         reference: tx.reference_no || tx.reference_no || `TRX-${tx.id}`,
    //             //         description: `Payment received for invoice '${inv.ref_no}'.`,
    //             //         debit: 0,
    //             //         credit: paid,
    //             //         advance: overpaid > 0 ? overpaid : 0,
    //             //         runningBalance,
    //             //         meta: { kind: 'payment' }
    //             //     });
    //             // });
    //             // relatedPayments.forEach(tx => {
    //             //     const paid = Math.abs(Number(tx.amount)) || 0;
    //             //     const received = Number(tx.received_amount) || paid;
    //             //     const overpaid = received > paid ? received - paid : 0;

    //             //     // Apply only actual invoice payment to balance
    //             //     const appliedToInvoice = paid;

    //             //     totalCredit += appliedToInvoice;
    //             //     runningBalance -= appliedToInvoice; // only reduce actual invoice amount

    //             //     // if (overpaid > 0) {
    //             //     //     invoiceAdvance += overpaid; // store advance separately
    //             //     //     totalAdvance += overpaid;
    //             //     //     // Do NOT subtract overpaid amount again from runningBalance
    //             //     // }
    //             //     if (overpaid > 0) {
    //             //         carryForwardAdvance += overpaid; // store extra as advance for next invoices
    //             //     }

    //             //     groupedData.push({
    //             //         date: tx.date,
    //             //         type: 'Payment',
    //             //         reference: tx.reference_no || `TRX-${tx.id}`,
    //             //         description: `Payment received for invoice '${inv.ref_no}'.`,
    //             //         debit: 0,
    //             //         credit: appliedToInvoice,
    //             //         advance: overpaid > 0 ? overpaid : 0,
    //             //         runningBalance,
    //             //         meta: { kind: 'payment' }
    //             //     });
    //             // });
    //             relatedPayments.forEach(tx => {
    //                 // Use the received_amount if present, fallback to amount
    //                 const received = Number(tx.received_amount) || Math.abs(Number(tx.amount)) || 0;

    //                 // Paid amount for invoice = min(received, invoice balance)
    //                 const appliedToInvoice = Math.min(received, runningBalance + appliedAdvance);

    //                 // Any extra payment beyond invoice amount is advance
    //                 const overpaid = received - appliedToInvoice;

    //                 totalCredit += appliedToInvoice;
    //                 runningBalance -= appliedToInvoice;

    //                 if (overpaid > 0) {
    //                     carryForwardAdvance += overpaid;
    //                 }

    //                 groupedData.push({
    //                     date: tx.date,
    //                     type: 'Payment',
    //                     reference: tx.reference_no || `TRX-${tx.id}`,
    //                     description: `Payment received for invoice '${inv.ref_no}'.`,
    //                     debit: 0,
    //                     credit: appliedToInvoice, // show actual received applied to invoice
    //                     advance: overpaid > 0 ? overpaid : 0, // show extra as advance
    //                     runningBalance,
    //                     meta: { kind: 'payment' }
    //                 });
    //             });


    //             // Update advance for invoice row (optional, if you want invoice row to show advance)
    //             if (invoiceAdvance > 0) {
    //                 const invoiceRow = groupedData.find(
    //                     row => row.meta.kind === 'invoice' && row.meta.invoiceId === inv.id
    //                 );
    //                 if (invoiceRow) invoiceRow.advance = invoiceAdvance;
    //             }

    //             totalAdvance += invoiceAdvance;

    //             // Leftover overpayment
    //             const paidTotal = relatedPayments.reduce((sum, p) => sum + Math.abs(Number(p.amount)) || 0, 0);
    //             const outstanding = total - appliedAdvance - paidTotal;
    //             if (outstanding < 0) carryForwardAdvance += Math.abs(outstanding);
    //         });
    //     });

    //     // Leftover advance
    //     if (carryForwardAdvance > 0) {
    //         groupedData.push({
    //             date: new Date(),
    //             type: 'Advance Carry Forward',
    //             reference: '-',
    //             description: `Advance balance carried forward to next orders.`,
    //             debit: 0,
    //             credit: 0,
    //             advance: carryForwardAdvance,
    //             runningBalance,
    //             meta: { kind: 'advance' }
    //         });
    //     }

    //     const openingBalance = 0;
    //     const closingBalance = runningBalance;

    //     return {
    //         transactions: groupedData,
    //         summary: {
    //             openingBalance,
    //             totalDebit,
    //             totalCredit,
    //             totalVAT,
    //             totalAdvance,
    //             closingBalance,
    //             currency
    //         }
    //     };
    // };

// const processSOAData = (deals, invoices, transactions, currency, vatRate) => {
//     const isAED = currency === 'AED';
//     const groupedData = [];
//     let runningBalance = 0;
//     let totalDebit = 0;
//     let totalCredit = 0;
//     let totalVAT = 0;
//     let totalAdvance = 0;
//     let carryForwardAdvance = 0;

//     // Step 1: Map quotation_id → deal_id
//     const quotationToDealMap = {};
//     deals.forEach(deal => {
//         if (deal.quotation_id) {
//             quotationToDealMap[deal.quotation_id] = deal.id;
//         }
//     });

//     // Step 2: Group invoices by deal_id
//     const invoicesByDeal = {};
//     const invoiceMap = {};
//     const invoiceAmounts = {};
    
//     invoices.forEach(inv => {
//         const dealId = quotationToDealMap[inv.quotation_id] || inv.deal_id;

//         if (!dealId) {
//             console.warn('Invoice not linked to a deal:', inv.ref_no);
//             return;
//         }

//         if (!invoicesByDeal[dealId]) invoicesByDeal[dealId] = [];
//         invoicesByDeal[dealId].push(inv);
//         invoiceMap[inv.id] = inv;
        
//         const amount = Number(inv.basic_amount) || 0;
//         const vat = isAED ? Number(inv.vat) || 0 : 0;
//         invoiceAmounts[inv.id] = amount + vat;
//     });

//     // Track which invoices have been paid and how much
//     const invoicePayments = {};
//     Object.keys(invoiceMap).forEach(id => {
//         invoicePayments[id] = 0;
//     });

//     // Process deals in order
//     const orderedDeals = [...deals].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

//     // FIRST: Process ALL deals to create Sales Declaration rows
//     orderedDeals.forEach(deal => {
//         const relatedInvoices = invoicesByDeal[deal.id] || [];
        
//         // ALWAYS add Sales Declaration row if there are invoices for this deal
//         if (relatedInvoices.length > 0) {
//             // 1️⃣ Sales Declaration - ALWAYS shows balance 0
//             groupedData.push({
//                 date: deal.issue_date || deal.created_at,
//                 type: 'Sales Declaration',
//                 reference: deal.po_number || `DEAL-${deal.id}`,
//                 description: `Order '${deal.name}' confirmed.`,
//                 debit: 0,
//                 credit: 0,
//                 advance: 0,
//                 runningBalance: 0, // ALWAYS 0 for Sales Declaration
//                 meta: { kind: 'order', dealId: deal.id }
//             });
            
//             console.log(`Added Sales Declaration for deal ${deal.id}: ${deal.name}`); // Debug log
//         }
//     });

//     // SECOND: Process ALL invoices sorted by date
//     const allInvoices = [...invoices].sort((a, b) => {
//         const dateA = new Date(a.invoice_date || a.issue_date || a.created_at);
//         const dateB = new Date(b.invoice_date || b.issue_date || b.created_at);
//         return dateA - dateB;
//     });

//     allInvoices.forEach(inv => {
//         const invoiceDate = inv.invoice_date || inv.issue_date || inv.created_at;
//         const amount = Number(inv.basic_amount) || 0;
//         const vat = isAED ? Number(inv.vat) || 0 : 0;
//         const total = Number(inv.total_with_vat) || (amount + vat);
        
//         // Check if there's advance to apply
//         let appliedAdvance = 0;
//         if (carryForwardAdvance > 0) {
//             appliedAdvance = Math.min(carryForwardAdvance, total);
//             carryForwardAdvance -= appliedAdvance;
//             totalCredit += appliedAdvance;
//         }
        
//         runningBalance += (total - appliedAdvance);
//         totalDebit += total;
//         totalVAT += vat;
        
//         // Invoice row - shows actual running balance
//         groupedData.push({
//             date: invoiceDate,
//             type: 'Invoice Raised',
//             reference: inv.ref_no || `INV-${inv.id}`,
//             description: `Invoice '${inv.ref_no}' for project '${inv.quotation?.project?.name || 'N/A'}'.`,
//             debit: total,
//             credit: appliedAdvance,
//             advance: 0,
//             runningBalance: runningBalance,
//             meta: { 
//                 kind: 'invoice', 
//                 invoiceId: inv.id,
//                 invoiceAmount: total
//             }
//         });
        
//         console.log(`Added Invoice for deal ${inv.deal_id}: ${inv.ref_no}, Balance: ${runningBalance}`); // Debug log
//     });

//     // THIRD: Process payments
//     const sortedPayments = [...transactions].sort((a, b) => new Date(a.date) - new Date(b.date));
    
//     sortedPayments.forEach(tx => {
//         const paymentAmount = Math.abs(Number(tx.amount)) || 0;
//         const receivedAmount = Number(tx.received_amount) || paymentAmount;
        
//         // Determine which invoices to apply payment to
//         let remainingPayment = receivedAmount;
//         let appliedCredit = 0;
        
//         // Try to apply to oldest outstanding invoices first
//         Object.keys(invoicePayments)
//             .sort((a, b) => new Date(invoiceMap[a]?.created_at) - new Date(invoiceMap[b]?.created_at))
//             .forEach(invId => {
//                 if (remainingPayment <= 0) return;
                
//                 const invoiceTotal = invoiceAmounts[invId] || 0;
//                 const alreadyPaid = invoicePayments[invId] || 0;
//                 const outstanding = invoiceTotal - alreadyPaid;
                
//                 if (outstanding > 0) {
//                     const applied = Math.min(remainingPayment, outstanding);
//                     invoicePayments[invId] = alreadyPaid + applied;
//                     remainingPayment -= applied;
//                     appliedCredit += applied;
//                 }
//             });
        
//         totalCredit += appliedCredit;
//         runningBalance -= appliedCredit;
        
//         // Any leftover is advance
//         let advance = 0;
//         if (remainingPayment > 0) {
//             advance = remainingPayment;
//             carryForwardAdvance += advance;
//             totalAdvance += advance;
//         }
        
//         // Payment row
//         groupedData.push({
//             date: tx.date,
//             type: 'Payment Received',
//             reference: tx.reference_no || `TRX-${tx.id}`,
//             description: tx.description || `Payment received`,
//             debit: 0,
//             credit: appliedCredit,
//             advance: advance,
//             runningBalance: runningBalance,
//             meta: { 
//                 kind: 'payment',
//                 transactionId: tx.id
//             }
//         });
        
//         console.log(`Added Payment: ${tx.reference_no}, Applied: ${appliedCredit}, Advance: ${advance}, Balance: ${runningBalance}`); // Debug log
//     });

//     // FOURTH: Add carry forward advance row if any
//     if (carryForwardAdvance > 0) {
//         groupedData.push({
//             date: new Date(),
//             type: 'Advance Carry Forward',
//             reference: '-',
//             description: `Advance balance carried forward to next orders.`,
//             debit: 0,
//             credit: 0,
//             advance: carryForwardAdvance,
//             runningBalance: runningBalance,
//             meta: { kind: 'advance' }
//         });
//     }

//     // FIFTH: Sort all rows by date for final display
//     groupedData.sort((a, b) => {
//         const dateA = new Date(a.date);
//         const dateB = new Date(b.date);
//         return dateA - dateB;
//     });

//     console.log('Final grouped data:', groupedData); // Debug log
    
//     const openingBalance = 0;
//     const closingBalance = runningBalance;

//     return {
//         transactions: groupedData,
//         summary: {
//             openingBalance,
//             totalDebit,
//             totalCredit,
//             totalVAT,
//             totalAdvance: carryForwardAdvance,
//             closingBalance,
//             currency
//         }
//     };
// };


const processSOAData = (deals, invoices, transactions, currency, vatRate) => {
    const isAED = currency === 'AED';
    const groupedData = [];
    let runningBalance = 0;
    let totalDebit = 0;
    let totalCredit = 0;
    let totalVAT = 0;
    let totalAdvance = 0;
    let carryForwardAdvance = 0;

    // Step 1: Map quotation_id → deal_id
    const quotationToDealMap = {};
    deals.forEach(deal => {
        if (deal.quotation_id) {
            quotationToDealMap[deal.quotation_id] = deal.id;
        }
    });

    // Step 2: Create comprehensive invoice map
    const invoicesByDeal = {};
    const invoiceMap = {};
    const invoiceAmounts = {};
    const invoiceTotalPayments = {}; // Track total payments per invoice
    
    invoices.forEach(inv => {
        const dealId = quotationToDealMap[inv.quotation_id] || inv.deal_id;

        if (!dealId) {
            console.warn('Invoice not linked to a deal:', inv);
            return;
        }

        if (!invoicesByDeal[dealId]) invoicesByDeal[dealId] = [];
        invoicesByDeal[dealId].push(inv);
        
        // Calculate invoice total
        const amount = Number(inv.basic_amount) || 0;
        const vat = isAED ? Number(inv.vat) || 0 : 0;
        const total = Number(inv.total_with_vat) || (amount + vat);
        
        invoiceMap[inv.id] = {
            ...inv,
            ref_no: inv.ref_no || inv.reference_no || inv.invoice_number || `INV-${inv.id}`,
            dealId: dealId,
            totalAmount: total
        };
        
        invoiceAmounts[inv.id] = total;
        invoiceTotalPayments[inv.id] = 0; // Initialize payment tracker
    });

    // Track which invoices have been paid and how much (initialize from invoice data if available)
    const invoicePayments = {};
    Object.keys(invoiceMap).forEach(id => {
        // If invoice has payment status info, use it; otherwise start at 0
        const invoice = invoiceMap[id];
        const paidAmount = Number(invoice.paid_amount) || Number(invoice.amount_paid) || 0;
        invoicePayments[id] = paidAmount;
    });

    // Process deals in order
    const orderedDeals = [...deals].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

    // FIRST: Process ALL deals to create Sales Declaration rows
    orderedDeals.forEach(deal => {
        const relatedInvoices = invoicesByDeal[deal.id] || [];
        
        if (relatedInvoices.length > 0) {
            groupedData.push({
                date: deal.issue_date || deal.created_at,
                type: 'Sales Declaration',
                reference: deal.po_number || `DEAL-${deal.id}`,
                description: `Order '${deal.name}' confirmed.`,
                debit: 0,
                credit: 0,
                advance: 0,
                runningBalance: 0,
                meta: { kind: 'order', dealId: deal.id }
            });
        }
    });

    // SECOND: Process ALL invoices sorted by date
    const allInvoices = [...invoices].sort((a, b) => {
        const dateA = new Date(a.invoice_date || a.issue_date || a.created_at);
        const dateB = new Date(b.invoice_date || b.issue_date || b.created_at);
        return dateA - dateB;
    });

    allInvoices.forEach(inv => {
        const invoiceDate = inv.invoice_date || inv.issue_date || inv.created_at;
        const invoiceTotal = invoiceAmounts[inv.id] || 0;
        
        let appliedAdvance = 0;
        if (carryForwardAdvance > 0) {
            appliedAdvance = Math.min(carryForwardAdvance, invoiceTotal);
            carryForwardAdvance -= appliedAdvance;
            totalCredit += appliedAdvance;
        }
        
        // Update invoice payment with any advance applied
        invoicePayments[inv.id] = (invoicePayments[inv.id] || 0) + appliedAdvance;
        
        runningBalance += (invoiceTotal - appliedAdvance);
        totalDebit += invoiceTotal;
        
        // Calculate VAT from invoice data
        const vat = isAED ? Number(inv.vat) || 0 : 0;
        totalVAT += vat;
        
        const invoiceRef = invoiceMap[inv.id]?.ref_no || `INV-${inv.id}`;
        
        groupedData.push({
            date: invoiceDate,
            type: 'Invoice Raised',
            reference: invoiceRef,
            description: `Invoice '${invoiceRef}' for project '${inv.quotation?.project?.name || 'N/A'}'.`,
            debit: invoiceTotal,
            credit: appliedAdvance,
            advance: 0,
            runningBalance: runningBalance,
            meta: { 
                kind: 'invoice', 
                invoiceId: inv.id,
                invoiceAmount: invoiceTotal
            }
        });
    });

    // THIRD: Process payments with detailed invoice information
    const sortedPayments = [...transactions].sort((a, b) => new Date(a.date) - new Date(b.date));
    
    sortedPayments.forEach(tx => {
        console.log('Processing payment:', tx.id, 'Amount:', tx.amount, 'Received:', tx.received_amount);
        
        const paymentAmount = Math.abs(Number(tx.amount)) || 0;
        const receivedAmount = Number(tx.received_amount) || paymentAmount;
        
        // Get invoice allocations from transaction data
        const transactionInvoices = [];
        
        // Check different possible structures for invoice references
        if (tx.invoices && Array.isArray(tx.invoices)) {
            tx.invoices.forEach(inv => {
                transactionInvoices.push({
                    invoiceId: inv.id,
                    invoiceRef: inv.ref_no || inv.reference_no || inv.invoice_number || `INV-${inv.id}`,
                    allocatedAmount: Number(inv.pivot?.allocated_amount) || Number(inv.allocated_amount) || 0
                });
            });
        } else if (tx.transaction_invoice_items && Array.isArray(tx.transaction_invoice_items)) {
            tx.transaction_invoice_items.forEach(item => {
                if (item.invoice) {
                    const inv = item.invoice;
                    transactionInvoices.push({
                        invoiceId: inv.id,
                        invoiceRef: inv.ref_no || inv.reference_no || inv.invoice_number || `INV-${inv.id}`,
                        allocatedAmount: Number(item.allocated_amount) || Number(item.paid_amount) || 0
                    });
                }
            });
        } else if (tx.invoice_id) {
            const invoiceRef = invoiceMap[tx.invoice_id]?.ref_no || `INV-${tx.invoice_id}`;
            transactionInvoices.push({
                invoiceId: tx.invoice_id,
                invoiceRef: invoiceRef,
                allocatedAmount: receivedAmount
            });
        }
        
        console.log('Transaction invoices found:', transactionInvoices);
        
        // Store which invoices this payment applies to and how much
        const paidInvoices = [];
        let remainingPayment = receivedAmount;
        let appliedCredit = 0;
        
        // First, apply payments based on transaction invoice allocations
        if (transactionInvoices.length > 0) {
            transactionInvoices.forEach(txInv => {
                if (remainingPayment <= 0) return;
                
                const invoiceId = txInv.invoiceId;
                const allocatedAmount = txInv.allocatedAmount || 0;
                const invoiceTotal = invoiceAmounts[invoiceId] || 0;
                const alreadyPaid = invoicePayments[invoiceId] || 0;
                const outstanding = invoiceTotal - alreadyPaid;
                
                console.log(`Invoice ${invoiceId} (${txInv.invoiceRef}): Total=${invoiceTotal}, AlreadyPaid=${alreadyPaid}, Outstanding=${outstanding}, Allocated=${allocatedAmount}`);
                
                if (outstanding > 0 && allocatedAmount > 0) {
                    // Don't apply more than what's allocated AND what's outstanding
                    const maxApplicable = Math.min(allocatedAmount, outstanding, remainingPayment);
                    
                    if (maxApplicable > 0) {
                        invoicePayments[invoiceId] = alreadyPaid + maxApplicable;
                        remainingPayment -= maxApplicable;
                        appliedCredit += maxApplicable;
                        
                        paidInvoices.push({
                            invoiceId: invoiceId,
                            invoiceRef: txInv.invoiceRef,
                            amountPaid: maxApplicable,
                            totalAmount: invoiceTotal,
                            alreadyPaidBefore: alreadyPaid,
                            remainingAfter: invoiceTotal - (alreadyPaid + maxApplicable)
                        });
                        
                        console.log(`Applied ${maxApplicable} to invoice ${invoiceId}. Remaining payment: ${remainingPayment}`);
                    }
                }
            });
        }
        
        // If still have payment left, apply to oldest outstanding invoices
        if (remainingPayment > 0) {
            console.log(`Applying remaining ${remainingPayment} to oldest outstanding invoices`);
            
            Object.keys(invoicePayments)
                .sort((a, b) => new Date(invoiceMap[a]?.created_at) - new Date(invoiceMap[b]?.created_at))
                .forEach(invId => {
                    if (remainingPayment <= 0) return;
                    
                    const invoiceTotal = invoiceAmounts[invId] || 0;
                    const alreadyPaid = invoicePayments[invId] || 0;
                    const outstanding = invoiceTotal - alreadyPaid;
                    
                    if (outstanding > 0) {
                        const applied = Math.min(remainingPayment, outstanding);
                        invoicePayments[invId] = alreadyPaid + applied;
                        remainingPayment -= applied;
                        appliedCredit += applied;
                        
                        // Check if already added this invoice
                        const existingIndex = paidInvoices.findIndex(p => p.invoiceId === invId);
                        const invoiceRef = invoiceMap[invId]?.ref_no || `INV-${invId}`;
                        
                        if (existingIndex >= 0) {
                            paidInvoices[existingIndex].amountPaid += applied;
                        } else {
                            paidInvoices.push({
                                invoiceId: invId,
                                invoiceRef: invoiceRef,
                                amountPaid: applied,
                                totalAmount: invoiceTotal,
                                alreadyPaidBefore: alreadyPaid,
                                remainingAfter: invoiceTotal - (alreadyPaid + applied)
                            });
                        }
                        
                        console.log(`Applied ${applied} to invoice ${invId} (${invoiceRef}). Remaining: ${remainingPayment}`);
                    }
                });
        }
        
        console.log(`Final payment allocation: Applied=${appliedCredit}, Remaining=${remainingPayment}, PaidInvoices:`, paidInvoices);
        
        totalCredit += appliedCredit;
        runningBalance -= appliedCredit;
        
        // Any leftover is advance
        let advance = 0;
        if (remainingPayment > 0) {
            advance = remainingPayment;
            carryForwardAdvance += advance;
            totalAdvance += advance;
        }
        
        // Create payment description based on paid invoices
        let paymentDescription = '';
        if (paidInvoices.length === 0) {
            paymentDescription = 'Advance payment received (no specific invoice).';
        } else if (paidInvoices.length === 1) {
            const inv = paidInvoices[0];
            paymentDescription = `Payment received for invoice '${inv.invoiceRef}' (${formatNumber(inv.amountPaid)} of ${formatNumber(inv.totalAmount)}).`;
            
            // If this is a partial payment, show remaining
            const remaining = inv.totalAmount - (inv.alreadyPaidBefore + inv.amountPaid);
            if (remaining > 0) {
                paymentDescription += ` Remaining: ${formatNumber(remaining)}.`;
            }
        } else {
            const invoiceRefs = paidInvoices.map(inv => `'${inv.invoiceRef}'`).join(', ');
            const totalPaid = paidInvoices.reduce((sum, inv) => sum + inv.amountPaid, 0);
            paymentDescription = `Payment received for ${paidInvoices.length} invoices: ${invoiceRefs} (Total: ${formatNumber(totalPaid)}).`;
        }
        
        // If there's advance, add that to description
        if (advance > 0) {
            paymentDescription += ` ${formatNumber(advance)} advance carried forward.`;
        }
        
        // Payment row
        groupedData.push({
            date: tx.date,
            type: 'Payment Received',
            reference: tx.reference_no || `TRX-${tx.id}`,
            description: paymentDescription,
            debit: 0,
            credit: appliedCredit,
            advance: advance,
            runningBalance: runningBalance,
            meta: { 
                kind: 'payment',
                transactionId: tx.id,
                paidInvoices: paidInvoices
            }
        });
        
        console.log('--- Payment processed ---');
    });

    // FOURTH: Debug - show final invoice payment status
    console.log('=== FINAL INVOICE PAYMENT STATUS ===');
    Object.keys(invoiceMap).forEach(invId => {
        const inv = invoiceMap[invId];
        const total = invoiceAmounts[invId] || 0;
        const paid = invoicePayments[invId] || 0;
        const outstanding = total - paid;
        
        console.log(`Invoice ${inv.ref_no}: Total=${total}, Paid=${paid}, Outstanding=${outstanding}`);
    });
    console.log('=== END STATUS ===');

    // FIFTH: Add carry forward advance row if any
    if (carryForwardAdvance > 0) {
        groupedData.push({
            date: new Date(),
            type: 'Advance Carry Forward',
            reference: '-',
            description: `Advance balance of ${formatNumber(carryForwardAdvance)} carried forward to next orders.`,
            debit: 0,
            credit: 0,
            advance: carryForwardAdvance,
            runningBalance: runningBalance,
            meta: { kind: 'advance' }
        });
    }

    // SIXTH: Sort all rows by date for final display
    groupedData.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA - dateB;
    });

    const openingBalance = 0;
    const closingBalance = runningBalance;

    return {
        transactions: groupedData,
        summary: {
            openingBalance,
            totalDebit,
            totalCredit,
            totalVAT,
            totalAdvance: carryForwardAdvance,
            closingBalance,
            currency
        }
    };
};


    const formatNumber = (amount) => {
        // Handle invalid amounts
        if (isNaN(amount) || amount === null || amount === undefined) {
            amount = 0;
        }

        return new Intl.NumberFormat('en-AE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    const formatCurrency = (amount, currency = 'AED') => {
        // Handle invalid amounts
        if (isNaN(amount) || amount === null || amount === undefined) {
            amount = 0;
        }

        return new Intl.NumberFormat('en-AE', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2
        }).format(amount);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        try {
            return new Date(dateString).toLocaleDateString('en-GB');
        } catch (error) {
            console.error('Error formatting date:', error);
            return '-';
        }
    };

    const resetFilters = () => {
        setSelectedClient('');
        setStartDate('');
        setEndDate('');
        setSoaData([]);
        setSummary({
            openingBalance: 0,
            totalDebit: 0,
            totalCredit: 0,
            totalVAT: 0,
            closingBalance: 0,
            currency: 'AED'
        });
    };

    // Filter transactions by date range
    const filteredTransactions = soaData.filter(transaction => {
        if (!startDate && !endDate) return true;

        try {
            const transactionDate = new Date(transaction.date);
            const fromDate = startDate ? new Date(startDate) : null;
            const toDate = endDate ? new Date(endDate) : null;

            if (fromDate && toDate) {
                return transactionDate >= fromDate && transactionDate <= toDate;
            } else if (fromDate) {
                return transactionDate >= fromDate;
            } else if (toDate) {
                return transactionDate <= toDate;
            }
        } catch (error) {
            console.error('Error filtering transactions by date:', error);
            return true;
        }

        return true;
    });

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <div>
                                    <h4 className="mb-0 font-size-18">Statement of Accounts</h4>
                                    <ol className="breadcrumb m-0 mt-2">
                                        <li className="breadcrumb-item">Accounts</li>
                                        <li className="breadcrumb-item active">SOA</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Card className="shadow-sm">
                        {/* <Card.Header className="bg-white text-black">
                            <h4 className="mb-0">Statement of Account</h4>
                        </Card.Header> */}
                        <Card.Header className="bg-white text-black d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">Statement of Account</h4>
                            <Button
                                variant="primary-outline"
                                className="d-flex align-items-center gap-2"
                                onClick={async () => {
                                    if (!selectedClient) return alert("Please select a client first");

                                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                                    const origin = localStorage.getItem('user-origin');
                                    const token = userInfo?.token;

                                    const params = new URLSearchParams({
                                        client_id: selectedClient,
                                        start_date: startDate,
                                        end_date: endDate,
                                    });

                                    const response = await fetch(`${backendUrl}/api/soa/download?${params.toString()}`, {
                                        method: 'GET',
                                        headers: {
                                            Authorization: `Bearer ${token}`,
                                            'Tenant-Origin': origin,
                                        },
                                    });

                                    const blob = await response.blob();
                                    const link = document.createElement('a');
                                    link.href = window.URL.createObjectURL(blob);
                                    link.download = `SOA_${selectedClient}_${new Date().toISOString().slice(0, 10)}.pdf`;
                                    link.click();
                                }}
                            >
                                <FaDownload /> Download
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            {/* Filters */}
                            <Row className="mb-4">
                                <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>Client</Form.Label>
                                        <Form.Select value={selectedClient} onChange={e => setSelectedClient(e.target.value)}>
                                            <option value="">Select Client</option>
                                            {clients.map(c => (
                                                <option key={c.id} value={c.id}>
                                                    {c.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {/* <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>Partner</Form.Label>
                                        <Form.Select
                                            value={selectedPartner}
                                            onChange={e => setSelectedPartner(e.target.value)}
                                        >
                                            <option value="">Select Partner</option>
                                            {partners.map(p => (
                                                <option key={p.id} value={p.id}>{p.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col> */}

                                <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>From Date</Form.Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                views={["year", "month", "day"]}
                                                format="DD-MM-YYYY"
                                                value={getDayjsDate(startDate)}
                                                onChange={(newValue) => {
                                                    setStartDate(newValue ? newValue.format('YYYY-MM-DD') : '');
                                                }}
                                                slotProps={{
                                                    textField: { size: "small", fullWidth: true },
                                                    popper: { sx: { "& .MuiPaper-root": { fontSize: "0.7rem", minWidth: 260 } } },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>To Date</Form.Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>

                                            <DatePicker
                                                views={["year", "month", "day"]}
                                                format="DD-MM-YYYY"
                                                value={getDayjsDate(endDate)}
                                                onChange={(newValue) => {
                                                    setEndDate(newValue ? newValue.format('YYYY-MM-DD') : '');
                                                }}
                                                slotProps={{
                                                    textField: { size: "small", fullWidth: true },
                                                    popper: { sx: { "& .MuiPaper-root": { fontSize: "0.7rem", minWidth: 260 } } },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Form.Group>
                                </Col>
                                <Col md={4} className="d-flex align-items-end gap-2">
                                    <Button variant="primary" onClick={fetchSOAData} disabled={loading || !selectedClient}>
                                        {loading ? <Spinner animation="border" size="sm" /> : 'Generate'}
                                    </Button>
                                    <Button variant="outline-secondary" onClick={resetFilters}>Reset</Button>
                                </Col>
                            </Row>

                            {/* Summary Cards */}
                            {filteredTransactions.length > 0 && (
                                <Row className="mb-4">
                                    {/* <Col md={2}>
                                        <Card className="border-primary text-center">
                                            <Card.Body className="p-3">
                                                <h6 className="mb-1">Opening Balance</h6>
                                                <h5 className="text-primary mb-0">{formatCurrency(summary.openingBalance, summary.currency)}</h5>
                                            </Card.Body>
                                        </Card>
                                    </Col> */}
                                    <Col md={2}></Col>
                                    <Col md={2}>
                                        <Card className="border-info text-center">
                                            <Card.Body className="p-3">
                                                <h6 className="mb-1">Total Debit</h6>
                                                <h5 className="text-info mb-0">{formatCurrency(summary.totalDebit, summary.currency)}</h5>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className="border-success text-center">
                                            <Card.Body className="p-3">
                                                <h6 className="mb-1">Total Credit</h6>
                                                <h5 className="text-success mb-0">{formatCurrency(summary.totalCredit, summary.currency)}</h5>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className="border-warning text-center">
                                            <Card.Body className="p-3">
                                                <h6 className="mb-1">Total VAT</h6>
                                                <h5 className="text-warning mb-0">{formatCurrency(summary.totalVAT, summary.currency)}</h5>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className="border-secondary text-center">
                                            <Card.Body className="p-3">
                                                <h6 className="mb-1">Net Amount</h6>
                                                <h5 className="text-secondary mb-0">{formatCurrency(summary.totalDebit - summary.totalCredit, summary.currency)}</h5>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    {/* <Col md={2}>
                                        <Card className={`border-${summary.closingBalance > 0 ? 'danger' : 'success'} text-center`}>
                                            <Card.Body className="p-3">
                                                <h6 className="mb-1">Closing Balance</h6>
                                                <h5 className={summary.closingBalance > 0 ? 'text-danger' : 'text-success'}>
                                                    {formatCurrency(summary.closingBalance, summary.currency)}
                                                </h5>
                                            </Card.Body>
                                        </Card>
                                    </Col> */}
                                </Row>
                            )}

                            {/* SOA Table */}
                            {filteredTransactions.length > 0 ? (
                                <Card>
                                    <Card.Header className="bg-light">
                                        <h5 className="mb-0">
                                            Transaction History - {clients.find(c => c.id == selectedClient)?.name}
                                        </h5>
                                        <small className="text-muted">
                                            Period: {startDate ? formatDate(startDate) : 'Start'} to {endDate ? formatDate(endDate) : 'End'}
                                        </small>
                                    </Card.Header>
                                    <Card.Body className="p-0">
                                        <div className="table-responsive">
                                            <table className="table align-middle table-nowrap table-check table-list">

                                                <thead className="table-light">
                                                    <tr>
                                                        <th style={{ width: '8%' }}>Date</th>
                                                        <th style={{ width: '10%' }}>Type</th>
                                                        <th style={{ width: '10%' }}>Ref No</th>
                                                        <th>Description</th>
                                                        <th className="text-end" style={{ width: '10%' }}>Debit ({summary.currency})</th>
                                                        <th className="text-end" style={{ width: '10%' }}>Credit ({summary.currency})</th>
                                                        <th className="text-end" style={{ width: '10%' }}>Advance ({summary.currency})</th>
                                                        <th className="text-end" style={{ width: '10%' }}>Balance ({summary.currency})</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredTransactions.map((t, i) => (
                                                        <tr key={i}>
                                                            <td>{formatDate(t.date)}</td>
                                                            <td>{t.type}</td>
                                                            <td><code>{t.reference || '-'}</code></td>
                                                            <td className="text-start">{t.description || '-'}</td>

                                                            <td className="text-end text-danger fw-semibold">
                                                                {t.debit > 0 ? formatNumber(t.debit) : '-'}
                                                            </td>
                                                            <td className="text-end text-success fw-semibold">
                                                                {t.credit > 0 ? formatNumber(t.credit) : '-'}
                                                            </td>
                                                            <td className="text-end text-info fw-semibold">
                                                                {t.advance > 0 ? formatNumber(t.advance) : '-'}
                                                            </td>
                                                            <td
                                                                className={`text-end fw-bold ${t.runningBalance > 0
                                                                    ? 'text-danger'
                                                                    : t.runningBalance < 0
                                                                        ? 'text-success'
                                                                        : 'text-dark'
                                                                    }`}
                                                            >
                                                                {formatNumber(t.runningBalance)}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot className="fw-bold">
                                                    <tr>
                                                        <td colSpan="4" className="text-end">Totals:</td>
                                                        <td className="text-end text-danger">{formatNumber(summary.totalDebit)}</td>
                                                        <td className="text-end text-success">{formatNumber(summary.totalCredit)}</td>
                                                        <td className="text-end text-info">{formatNumber(summary.totalAdvance)}</td>
                                                        <td
                                                            className={`text-end ${summary.closingBalance > 0 ? 'text-danger' : 'text-success'
                                                                }`}
                                                        >
                                                            {formatNumber(summary.closingBalance)}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </Card.Body>

                                </Card>
                            ) : (
                                <Card>
                                    <Card.Body className="text-center py-5">
                                        <h5 className="text-muted">
                                            {selectedClient ? 'Select dates and generate SOA to view transactions' : 'Please select a client to generate Statement of Account'}
                                        </h5>
                                    </Card.Body>
                                </Card>
                            )}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default StatementOfAccounts;